import DailyIframe from "@daily-co/daily-js";
import http from "./http-util";
import dom from "./dom-util";
import common from "./common-util";
import config from "./config";
import dealer from "./dealer";
import React from "react";
import ReactDOM from "react-dom";
import NewWindow from "react-new-window";
import sdAnalytics from "./sdAnalytics";

class dailyCoCore {
  APIBASEURL = config.APIBASEURL;

  dailyFrameConfiguration = {
    iframeStyle: {
      visibilty: "hidden",
      position: "fixed",
      border: "2px solid black",
      background: "grey",
      width: "380px",
      height: "450px",
      left: "1em",
      bottom: "1em",
      "margin-bottom": "5%",
      transition: "all 1s",
      "z-index": 2147483647,
    },
    showLeaveButton: true,
    showFullscreenButton: true,
  };

  dailyMobileFrameConfiguration = {
    iframeStyle: {
      position: "fixed",
      background: "grey",
      width: "100%",
      "min-height": "640px",
      transition: "all 1s",
      bottom: "1em",
      "z-index": 2147483647,
    },
    showLeaveButton: true,
    showFullscreenButton: true,
  };

  createVideoWrapper = function (id) {
    let elementExist = document.getElementById(config.videocallwrapperdivId);
    if (elementExist) {
      elementExist.remove();
    }
    let iframeElement =
      '<div style="" id="' + config.videocallwrapperdivId + '"></div>';
    let divIframe = dom.createElementFromHTML(iframeElement);
    if (id) {
      document.getElementById(id).appendChild(divIframe);
    } else {
      document.body.appendChild(divIframe);
    }
  };

  openFrameInNewWindow(frameUrl) {
    let settings = dealer.getChatClientSettings();
    let onemin = 60000;
    let countdown = onemin * 2;
    if (settings) {
      countdown = settings.uiSettings.closeAfter * onemin;
    }
    let roomName = window.tgRoomName;
    let roomId = window.tgChatRoomId;
    let url =
      "https://web.tagrail.com/online/portal/scripts/tg-video-chat/app-stage/index.html?url=" +
      frameUrl +
      "&countdown=" +
      countdown +
      "&roomName=" +
      roomName +
      "&roomId=" +
      roomId;

    if (window.tgmeetingChildWindow && window.tgmeetingChildWindow.location) {
      window.tgmeetingChildWindow.location.href = url;
    } else {
      //let url = "http://localhost:3001/?url=" + frameUrl + "&countdown=" + countdown;
      const rootElement = document.getElementById(config.videocallwrapperdivId);
      let height = 450;
      let width = 380;
      let top = window.innerHeight - height;
      const Videoframe = () => {
        const newWindowUnloaded = (e) => {
          console.log("window unloaded");
          this.setMeetingState("left-meeting");
        };
        const newWindowLoaded = (videoFrameWindow) => {
          console.log("window loaded");
        };
        return (
          <NewWindow
            url={url}
            onOpen={(framewindow) => newWindowLoaded(framewindow)}
            onUnload={() => newWindowUnloaded()}
            name="tg-video-chat"
            title="video chat"
            center="none"
            copyStyles={false}
            features={{ top: top, width: width, height: height }}
          ></NewWindow>
        );
      };
      ReactDOM.render(<Videoframe />, rootElement);
    }
  }

  openEmptyFrameInNewWindow() {
    const rootElement = document.getElementById(config.videocallwrapperdivId);
    let height = 450;
    let width = 380;
    let top = window.innerHeight - height;
    const Videoframe = () => {
      const onLoad = (e) => {
        window.tgmeetingChildWindow = e;
        this.setMeetingState("active");
        console.log("window loaded");
        let sd = new sdAnalytics();
        sd.chatClick();
      };
      return (
        <NewWindow
          onOpen={(framewindow) => onLoad(framewindow)}
          name="tg-video-chat"
          title="Tagrail Video Chat"
          center="none"
          copyStyles={false}
          features={{ top: top, width: width, height: height }}
        >
          <label style={{ fontWeight: "bold" }}> Loading...</label>
        </NewWindow>
      );
    };

    ReactDOM.render(<Videoframe />, rootElement);
  }

  setupDailyFrame = (parentPopupId) => {
    let element = document.getElementById(config.videocallwrapperdivId);
    window.tgPopupId = parentPopupId;
    // window.tgvideowrapperDiv = parentIframeId;
    if (common.isMobile()) {
      window.callFrame = DailyIframe.createFrame(
        element,
        this.dailyMobileFrameConfiguration
      );
    } else {
      window.callFrame = DailyIframe.createFrame(
        element,
        this.dailyFrameConfiguration
      );
    }

    window.callFrame
      .on("loading", this.showEvent)
      .on("started-camera", this.showEvent)
      .on("camera-error", this.showEvent)
      .on("joining-meeting", this.showEvent)
      .on("participant-joined", function (e) {
        console.log("Participants joined");
        let participants = Object.values(window.callFrame.participants());
        let joinedUser = "";
        if (participants.length > 0) {
          joinedUser = participants[1].user_name;
        }

        window.tgVChatJoinedOwnerName = joinedUser;
        window.tgMeetingState = "joined";
      })
      .on("participant-updated", this.showEvent)
      .on("participant-left", this.showEvent)
      .on("recording-started", this.showEvent)
      .on("recording-stopped", this.showEvent)
      .on("recording-stats", this.showEvent)
      .on("recording-error", this.showEvent)
      .on("recording-upload-completed", this.showEvent)
      .on("app-message", function (e) {
        console.log("app-message:" + e);
      })
      .on("input-event", this.showEvent)
      .on("error", this.showEvent);

    window.callFrame.on("loaded", (e) => {
      dom.hide(config.tgvideoIconId);
      // this.buttonDisable('tg-join-meeting-icon');
    });

    window.callFrame.on("joined-meeting", (e) => {
      this.showEvent(e);
    });

    window.callFrame.on("left-meeting", (e) => {
      this.showEvent(e);
      window.tgMeetingState = "left-meeting";
      dealer.sendADF(e).then(function (adfresponse) {
        console.log(adfresponse);
      });
      window.callFrame.destroy();
      if (common.isMobile() && window.tgPopupId) {
        dom.show(window.tgPopupId);
      }
      dom.show(config.tgvideoIconId);
      // this.buttonEnable('tg-join-meeting-icon');

      this.deleteRoom(window.tgDealerId, dealer.getChatSessionId()).then(
        function (deleteRoomResponse) {
          if (deleteRoomResponse.success === 1) {
            if (deleteRoomResponse.result.deleted === true) {
              console.log("Room deleted");
            }
          }
        }
      );
    });

    this.autoLeave(300000); //sends adf if no user from dealership joins the call in 5 min
  };

  createRoom = (dealerId, chatSessionId, customer) => {
    const apiurl =
      this.APIBASEURL +
      "/v1/chat/create/room/" +
      dealerId +
      "/" +
      chatSessionId +
      "/private";

    let request = {
      chatSessionId: chatSessionId,
    };
    if (customer) {
      request.customerFirstName = customer.customerFirstName;
      request.customerLastName = customer.customerLastName;
    }
    const response = http.post(apiurl, request);
    return response;
  };

  joinRoom = (joinMeetingUrl) => {
    console.log("Join meeting");
    window.callFrame.join({
      url: joinMeetingUrl,
    });
  };

  inviteUser = (dealerId, chatSessionId, popupsessionId, invitedBy) => {
    console.log("Inviting user");

    let request = {};
    request = {
      chatSessionId: chatSessionId,
      sessionId: popupsessionId,
      roomId: window.tgChatRoomId,
    };

    if (invitedBy) {
      request.inviterFirstName = invitedBy.firstName;
      request.inviterLastName = invitedBy.lastName;
    }
    const apiurl =
      this.APIBASEURL +
      "/v1/chat/invite/user/" +
      dealerId +
      "/" +
      chatSessionId;
    const response = http.post(apiurl, request);
    return response;
  };

  deleteRoom = (dealerId, sessionId) => {
    const apiurl =
      this.APIBASEURL + "/v1/chat/delete/room/" + dealerId + "/" + sessionId;
    let chatRoomState = this.getChatRoomState();
    let response = null;
    if (chatRoomState !== "deleted") {
      response = http.delete(apiurl, {});
      if (response.success === 1) {
        this.setChatRoomState("deleted");
      }
    }
    return response;
  };

  getRoomName = (dealerId, sessionId) => {
    return dealerId + "-" + sessionId;
  };

  buttonDisable = (...args) => {
    args.forEach((id) => {
      let el = document.getElementById(id);
      if (el) {
        el.classList.add("disabled");
      }
    });
  };

  buttonEnable = (...args) => {
    args.forEach((id) => {
      let el = document.getElementById(id);
      if (el) {
        el.classList.remove("disabled");
      }
    });
  };

  showEvent = (e) => {
    console.log("callFrame event", e);
  };

  autoLeave(timeperiod) {
    setTimeout(function () {
      if (window.tgMeetingState !== "joined") {
        window.callFrame.leave();
      }
    }, timeperiod);
  }

  windowBringToTop(childwindow) {
    if (childwindow) {
      childwindow.focus();
    }
  }

  getMeetingState() {
    let state = sessionStorage.getItem("tg-chat-state");
    return state;
  }

  setMeetingState(state) {
    window.tgMeetingState = state;
    sessionStorage.setItem("tg-chat-state", state);
  }

  getChatRoomState() {
    let chatRoomState = sessionStorage.getItem("tg-chatroom-state");
    return chatRoomState;
  }
  setChatRoomState(state) {
    sessionStorage.setItem("tg-chatroom-state", state);
  }

  static keepChatInProgressIcon() {
    setInterval(function () {
      let meetingstate = window.tgMeetingState;
      let v3PopupIframe = document.querySelector("[tgiframeactive]");
      let V3PopupActive =
        v3PopupIframe && v3PopupIframe.getAttribute("tgiframeactive") === "1";

      if (meetingstate === "active" || meetingstate === "joined") {
        let callInProgressButton =
          '<div><a id="tg-join-meeting-inprogress-icon" style="" class="animated pulse" href="javascript:void(0)" onclick="showChatWindow();"><div style="text-align: center;"><img src="https://web.tagrail.com/online/portal/scripts/tg-video-chat/assets/call-inprogress.png" style="margin: 20%;width: 40px;display: inline-block;"></div></a></div>';

        if (window.$tg) {
          let callInProgressButtonPresentInV3 = window.$tg(
            "#popupWebdesking_v_3 #tg-join-meeting-inprogress-icon"
          );
          if (V3PopupActive && callInProgressButtonPresentInV3.length === 0) {
            let callInProgressButtonDiv =
              dom.createElementFromHTML(callInProgressButton);
            window.$tg(config.tgvideoInProgressIconId).remove();
            document
              .getElementById("popupWebdesking_v_3")
              .appendChild(callInProgressButtonDiv);
          }
        }
        if (
          !V3PopupActive &&
          !document.getElementById(config.tgvideoInProgressIconId)
        ) {
          let callInProgressButtonDiv =
            dom.createElementFromHTML(callInProgressButton);
          //window.$tg(config.tgvideoInProgressIconId).remove();
          document.body.appendChild(callInProgressButtonDiv);
        }
        dom.setStyle(config.tgvideoInProgressIconId, { visibility: "visible" });
        dom.hide(config.tgvideoIconId);
      }
      if (meetingstate === "inactive" || meetingstate === "left-meeting") {
        let vc_ui_settings = JSON.parse(
          sessionStorage.getItem("tg-vc-ui-settings")
        );
        dom.setStyle(config.tgvideoInProgressIconId, { visibility: "hidden" });
        if (!document.getElementById(config.tgvideoIconId)) {
          let buttonElement =
            '<div><a id="tg-join-meeting-icon" style="" class="animated pulse" href="javascript:void(0)" onclick="joinMeeting();"><div style="text-align: center;"><img src="https://web.tagrail.com/online/portal/scripts/tg-video-chat/assets/icon.png" style="margin: 20%;width: 40px;display: inline-block;"></div></a></div>';
          let divbutton = dom.createElementFromHTML(buttonElement);
          document.body.appendChild(divbutton);
        }

        if (V3PopupActive) {
          dom.hide(config.tgvideoIconId);
        }

        if (
          vc_ui_settings &&
          vc_ui_settings.uiSettings &&
          vc_ui_settings.showChatIcon
        ) {
          dom.show(config.tgvideoIconId);
        } else {
          dom.hide(config.tgvideoIconId);
        }
      }
    }, 100);
  }
  isMeetingActive() {
    let isactive = false;
    let meetingstate = sessionStorage.getItem("tg-chat-state");
    if (meetingstate === "active" || meetingstate === "joined") {
      isactive = true;
    }
    return isactive;
  }
}

export default dailyCoCore;
